import React from 'react';
import { 
    EditButton,
    List, 
    Datagrid,
    TextField, 
    TopToolbar,
    DateField,
    CardActions,
    ListButton,
    Show,
    SimpleShowLayout,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import LinkToCreate from  '../../controls/LinkToCreate';
import moment from 'moment';
import ErrorBoundary from '../../ErrorBoundary';

const useStyles = makeStyles({

    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
    inlineBlockLeft: {
        display: 'inline-flex',
        float:    'left', 
        marginRight: '1rem' 
    },
    hidden : {
        display: 'none' 
    },
    inputStyle : {
        width :'20px',
    },
    controlInputStyle : {
       width :'70px',
       fontSize: '8'
   },
    labelStyle : {
       width :'40px',
       backgroundColor: 'silver'
   },
   iniLabelStyle : {
       width :'20px',
       backgroundColor: 'silver'
   },
   dateStyle : {
       width: '120px',
       
   },
   tableStyle :{ 
       margin: 'auto',  
       fontSize:'12px', 
       fontWeight:'bold', 
       cellspacing:"3", 
       border:'1px solid  black', 
       width: "100%"
   },
   h3: {
       textAlign: 'center',
       width: '100%'
   },
   clearTableStyle :{ 
       margin: 'auto',  
       fontSize:'12px', 
       fontWeight:'bold', 
       cellspacing:"3", 
       border:'0px solid  black', 
       width: "100%"
   },
   inlineBlock: {
       display: 'inline-flex',
       margin: '5px',
       padding: '5px',
   },

});


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const CalActions = ({...props}) => (
    <CardActions style={cardActionStyle}>
        <LinkToCreate id={props.filterValues.ins_id} name='Create' path='/log_EQ_INC/create' />
        <ListButton basePath={'/loginstrument'} label="Log List" />
    </CardActions>
);


const Editable = ({record}) => {
    //console.log(record.editable);
    return record && record.is_qa > 0 ? '' : <EditButton  record={record} label='Update'/> ;
}

const ShowDetails = ({...props}) => {
    const classes = useStyles();
    var readings = [];

    //console.log(props.record)
    if(props && props.record && props.record.readings){
        try{
          readings =JSON.parse(props.record.readings) 
        } catch(e) {
          readings = props.record.readings;
        };
    }

    return(
            <table className={classes.tableStyle} >
            <tbody  > 
                <tr>
                    <td>
                    <table className={classes.clearTableStyle}>
                        <tbody>
                            <tr>
                                <td colSpan={4} ><center><h3>EQUIPMENT INCIDENT REPORT </h3></center></td>
                            </tr>
                            <tr>
                                <td>Center Name:</td><td><TextField source='center'  label=''  /></td>
                                <td>EQUIPMENT ITEM MFR / NAME :</td><td><TextField source='full_name'  label='' /></td>
                            </tr>
                        </tbody>
                    </table>
                    </td>
                </tr>
                <tr >
                <td>
                    <table className={classes.tableStyle} >
                    <tbody>
                    <tr>
                        <td colSpan={4} ><center><h3>REFRACTOMETER</h3></center></td>
                    </tr>
                    <tr>
                        <td>Center Name:</td><td><TextField source='center'  label=''/></td>
                        <td>Instrument Serial Number:</td><td><TextField source='serial_num'  label=''  /></td>
                    </tr>
                    
                    <tr>
                        <td>Date:</td><td><DateField source="eq_dt" label=""   locales='en-us' /></td>
                        <td>TYPE OF PROBLEM / DESCRIPTION OF DEFECT:</td><td><TextField source="defect" label=""   /></td>
                    </tr>
                    <tr>
                        <td>REPORTED TO:</td><td><TextField source="rpt_to" label=""   /></td>
                        <td>REPORTED by:</td><td><TextField source="rpt_by" label=""   /></td>
                    </tr>
                    <tr>
                        <td>RESOLUTION:</td><td><TextField source="resolution" label=""   /></td>
                        <td colSpan={2}>&nbsp;</td>
                    </tr>
                   
                    <tr>
                        <td>DATE REMOVED FROM SERVICE:</td><td><DateField source="rm_dt" label=""   locales='en-us' /></td>
                        <td>TECHNICIAN INITIAL:</td><td><TextField source="r_tech_init" label=""   /></td>
                    </tr>
                    <tr>
                        <td>DATE RETURNED TO SERVICE:</td><td><DateField source="r_tech_dt" label=""  locales='en-us' /></td>
                        <td colSpan={2}>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>TECHNICIAN INITIAL:</td><td><TextField source="tech_init" label=""   /></td>
                        <td>QA INITIAL:</td><td><TextField source="qa_init" label=""   /></td>
                    </tr>
                    </tbody>
                </table>
            </td>
        </tr>
                    
    </tbody>
</table>
    )
}

const PostShowActions = () => (
    <TopToolbar>
        <></>
    </TopToolbar>
);

const View= props =>(
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
        actions={<PostShowActions />}
    >
        <SimpleShowLayout   >
            <ShowDetails  />    
        </SimpleShowLayout>
    </Show>
);

const TechInitDate= ({record})=>(
    record && record.tech_date ? 
   <>
    {record.tech_init + ' on ' + moment(record.tech_date).format('MM/DD/YYYY')}
   </> : <>{record.tech_init}</>
)

const QAInitDate= ({record})=>(
    record && record.qa_date ? 
   <>
    {record.qa_init + ' on ' + moment(record.qa_date).format('MM/DD/YYYY')}
   </> : <>{record.qa_init}</>
)

export const InsList = ({...props }) => (
<ErrorBoundary>  
    <List 
        {...props}
        perPage={20}
        bulkActionButtons ={false}
        actions={<CalActions/>} 
        title ="Log | EQUIPMENT INCIDENT REPORT "
        >
        <Datagrid  expand={<View  {...props}  />} >
            <TextField source="ins_id" label="Equipment" />
            <TextField source="center" label="Center" />
            <Editable />
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default InsList;
